import * as React from "react";

export interface ShortProps {
    visible: boolean;
    children: React.ReactNode;
}

export function Short(props: ShortProps): React.ReactElement {
    return <>{props.visible && props.children}</>;
}
